import gql from 'graphql-tag';
import { useLazyQuery } from '@vue/apollo-composable';
import { useStore } from '~/store';
import { CORE_DASHBOARD_FIELDS } from '~/graphql/fragments';

/**
 * Offers utilities to manage the dashboard of the current user
 */
export default function useUserDashboards() {
  const store = useStore();
  const { onResult, load: loadAllDashboards } = useLazyQuery(
    gql`
        query AllDashboards {
            dashboards(first: 200, page:1) {
                data {
                    ...CoreDashboardFields
                }
            }
        }
        ${CORE_DASHBOARD_FIELDS}
    `,
    {},
    { fetchPolicy: 'cache-first' },
  );
  // Store all the dashboards
  onResult((result) => {
    store.commit('dashboard/commitDashboards', result.data?.dashboards?.data ?? []);
  });

  /**
   * Ensure all dashboards are loaded and available in the store
   */
  function ensureAllDashboards() {
    // Prevent fetching dashboards if we already have them
    if (store.getters['dashboard/getDashboards']?.length) {
      return Promise.resolve();
    }

    return loadAllDashboards();
  }

  return {
    ensureAllDashboards,
  };
}
